import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { BookingQuotation } from '../booking-quotation';
import { Currency } from '../currency';
import { SalesProductType } from '../sales-product-type';
import Decimal from 'decimal.js';
import { CKEDITORCONFIGMINIMAL, CKEDITORCONFIGMINIMALWITHLINK } from '../ckeditor-config';
import { HttpService } from '../service/http.service';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ExchangeRate } from '../exchange-rate';
import { map } from 'rxjs/operators';
import { SalesProduct } from '../sales-product';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-clone-booking-quotation',
  templateUrl: './clone-booking-quotation.component.html',
  styleUrls: ['./clone-booking-quotation.component.css']
})
export class CloneBookingQuotationComponent implements OnInit {

  @Input()
  selectedQuotation!: BookingQuotation;

  @Input()
  bookingId!: number;

  @Output()
  finishCloneEvent = new EventEmitter<boolean>();

  quotationForm!: FormGroup;
  productTypes: SalesProductType[] = [];
  currencies: Currency[] = [];
  productPriceInCurrency: string[] = [];
  productPriceInSecondCurrency: string[] = [];
  yearRange = "";

  totalPriceInCurrency: Decimal = new Decimal(0.00);
  totalPriceInSecondCurrency: Decimal = new Decimal(0.00);

  editorConfig = CKEDITORCONFIGMINIMAL;
  descriptionEditorConfig = CKEDITORCONFIGMINIMALWITHLINK;

  public Editor = Editor;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    this.yearRange = (moment().year() - 10) + ":" + (moment().year() + 4);
    this.httpService.getCurrencies().subscribe(currencies => {
      this.currencies = currencies;
    });
    this.httpService.getSalesProductTypes().subscribe(res => this.productTypes = res);
    this.quotationForm = this.builder.group({
      description: this.selectedQuotation.description,
      comment: this.selectedQuotation.comment,
      products: this.builder.array([]),
      baseCurrency: this.selectedQuotation.baseCurrency,
      secondCurrency: this.selectedQuotation.secondCurrency,
      quotationDate: moment().toDate(),
      dueDate: null,
      deposit: new Decimal(250.00),
      priceIncludes: this.selectedQuotation.priceIncludes,
      priceNotIncludes: this.selectedQuotation.priceNotIncludes
    });
    this.initProducts(this.selectedQuotation.productList);
  }


  mouseover(i: number) {
    let array = this.quotationForm.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(true);
  }
  mouseout(i: number) {
    let array = this.quotationForm.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(false);
  }

  moveItem(array: any[], i: number, delta: number) {
    let newIndex = i + delta;
    if (newIndex < 0 || newIndex >= array.length) {
      return;
    }
    let indexes = [i, newIndex].sort();
    array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
  }

  moveUp(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, -1);
  }

  moveDown(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, 1);
  }

  insertAt(array: AbstractControl[], index: number, element: FormGroup) {
    array.splice(index, 0, element);
  }

  insertItem(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    this.insertAt(itemArray.controls, i + 1, this.builder.group({
      type: this.productTypes[0],
      description: "",
      amount: [new Decimal(0.00), Validators.pattern(/^[.\d]+$/)],
      currency: new Currency(1, "Euro", "EUR", "€"),
      activeMenu: false
    }));
  }

  removeItem(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    itemArray.controls.splice(i, 1);
  }

  createQuotation() {
    let quotation = new BookingQuotation(
      this.quotationForm.value.description,
      this.quotationForm.value.comment,
      this.setProductList(),
      this.quotationForm.value.baseCurrency,
      this.quotationForm.value.secondCurrency,
      this.quotationForm.value.quotationDate == null ? null : moment(this.quotationForm.value.quotationDate).utc(true),
      this.quotationForm.value.dueDate == null ? null : moment(this.quotationForm.value.dueDate).utc(true),
      this.quotationForm.value.deposit,
      this.quotationForm.value.priceIncludes,
      this.quotationForm.value.priceNotIncludes);
      return this.httpService.postBookingQuotation(quotation, this.bookingId);
  }

  setProductList() {
    let products = [];
    let productFormArray = this.quotationForm.get("products") as FormArray;
    for (let product of productFormArray.controls) {
      products.push(new SalesProduct(
        product.get("type")!.value,
        product.get("description")!.value,
        new Decimal(product.get("amount")!.value),
        product.get("currency")!.value
      ));
    }
    return products;
  }

  initProducts(productList: SalesProduct[]) {
    let array = this.quotationForm.get("products") as FormArray;

    for (let product of productList) {
      array.controls.push(this.builder.group({
        type: product.productType,
        description: product.description,
        amount: product.amount.toFixed(2),
        currency: product.currency,
        activeMenu: false
      }));
      this.calculatePriceInCurrency(new Decimal(product.amount), product.currency,
        this.quotationForm.get("baseCurrency")!.value).subscribe(amount => {
          this.productPriceInCurrency.push(amount.toFixed(2));
          this.totalPriceInCurrency = this.totalPriceInCurrency.plus(amount.toFixed(2));
        });
      if (this.quotationForm.get("secondCurrency")!.value) {
        this.calculatePriceInCurrency(new Decimal(product.amount), product.currency,
          this.quotationForm.get("secondCurrency")!.value).subscribe(amount => {
            this.productPriceInSecondCurrency.push(amount.toFixed(2));
            this.totalPriceInSecondCurrency = this.totalPriceInSecondCurrency.plus(amount.toFixed(2));
          });
      }
    }
  }
  calculatePriceInCurrency(amount: Decimal, targetCurrency: Currency,
    baseCurrency: Currency): Observable<Decimal> {
    if (targetCurrency.id == baseCurrency.id) {
      return this.getExchangeRateFromEuro(baseCurrency, moment()).pipe(map(rate => {
        return amount;
      }));
    }
    if (targetCurrency.id == 1) {
      return this.getExchangeRateFromEuro(baseCurrency, moment()).pipe(map(rate => {
        return amount.times(rate.exchangeRate);
      }));
    } else if (baseCurrency.id == 1) {
      return this.getExchangeRateFromEuro(targetCurrency, moment()).pipe(map(rate => {
        return amount.times(new Decimal(1).dividedBy(rate.exchangeRate));
      }));
    } else {
      return this.getExchangeRateFromAnotherCurrency(targetCurrency, baseCurrency, moment())
        .pipe(map(rate => {
          return amount.times(rate.exchangeRate);
        }));
    }
  }
  // used to convert euro to another currency
  getExchangeRateFromEuro(currency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRate(currency, date, true);
  }

  getExchangeRateToEuro(currency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRateToEuro(currency, date, this.selectedQuotation.baseCurrency, true);
  }

  getExchangeRateFromAnotherCurrency(baseCurrency: Currency, targetCurrency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRateWithBaseCurrency(baseCurrency, targetCurrency, date, this.selectedQuotation.baseCurrency, true);
  }

  get productFormArray(){
    let form = this.quotationForm.get('products') as FormArray;
    return form.controls;
  }

  isHidden(index: number){
    let form = this.productFormArray;
    if(form[index].get('activeMenu')!.value){
      return false;
    }
    return true;
  }

}
